import type { JSX } from "react";
import { CloseIcon } from "./icons";

interface RecordingOffBarProps {
  /** Where its top sits, below the clock. */
  readonly top: string;
  readonly onTurnOn: () => void;
  readonly onClose: () => void;
}

/** The host's notice that the call is not being recorded, on the main call
 * screen (Adam, 2026-10-19: "put it on my main meeting screen until i turn it
 * on or x it out", "shouldn't appear till the other person joins"). When it
 * shows is CallScreen's call. */
export function RecordingOffBar({ top, onTurnOn, onClose }: RecordingOffBarProps): JSX.Element {
  return (
    <div className="recoff" role="status" data-testid="recording-off-banner" style={{ top }}>
      <span className="recoff__text">Meeting recording is off</span>
      <button type="button" className="recoff__on" onClick={onTurnOn}>
        Turn on
      </button>
      <button type="button" className="recoff__x" aria-label="Close" onClick={onClose}>
        <CloseIcon size={16} />
      </button>
    </div>
  );
}
